import React from 'react';
import ReactDOM from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'leaflet/dist/leaflet.css';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HorizontalFormContextProvider } from './context/HorizontalFormContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // REMOVE StrictMode
  //<React.StrictMode>
  <HorizontalFormContextProvider>
    <App />
  </HorizontalFormContextProvider>
  //</React.StrictMode>
);

// console.log('bbss:', window.bootstrap);

reportWebVitals();
